module.exports = "/_next/static/files/c79188b1f737b89e9f7b34282e194df6.svg";